import { workerService } from "@/services/WorkerService";
import {toast} from "vue3-toastify";

const state = {
    workersData: [],
    getWorkersRequest: {
        loading: false
    }
};

const actions = {
    getWorkersData({ commit }, date){
        commit("setGetWorkersRequest", {loading: true});
        workerService.getWorkersData(date?.startDate, date?.endDate)
            .then((response) => {
                commit("setGetWorkersRequest", {loading: false});
                commit("setWorkersData", response.data);
            })
            .catch((error) => {
                commit("setGetWorkersRequest", {loading: false, message: error});
                toast.warning(error);
            });
    }
}

const mutations = {
    setGetWorkersRequest(state, {loading, message}){
        state.getWorkersRequest = {loading, message};
    },
    setWorkersData(state, workersData){
        state.workersData = workersData;
    },
}


export const workerShift = {
    namespaced: true,
    state,
    actions,
    mutations
};
